module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"it":{"pageTitle":"Proposte Ricevute","NoOffersForEvent":"Nessun proposta trovata","offerReceived":"Ricevuto il "},"en":{"pageTitle":"Received Offers","NoOffersForEvent":"No offers found","offerReceived":"Received on "}}')
  delete Component.options._Ctor
}
